interface LinkAction {
  /** APPModel */
  readonly ADD_MENUCONTAIN: string;
  readonly ADD_TASKSEQUENCE: string;
  /** ProductModel */
  /** EntityModel */
  readonly ADD_ASSOCIATION: string;
  readonly ADD_IMPLEMENT: string;
  readonly ADD_GENERALIZATION: string;
  readonly ADD_DEPENDENCY: string;
  readonly ADD_COMPOSITION: string;
  readonly ADD_AGGREGATION: string;
  readonly ADD_CROSS: string;
}

interface TypeAction {
  /** Base */
  readonly ADD_APP: string;
  readonly ADD_PRODUCT: string;
  /** APPModel */
  readonly ADD_APPCOMPONENT: string;
  readonly ADD_APPCOMMENT: string;
  readonly ADD_MENUSET: string;
  readonly ADD_CONFIGGROUP: string;
  /** ProductModel */
  readonly ADD_PRODUCTCOMPONENT: string;
  readonly ADD_PRODUCTCOMMENT: string;
  readonly ADD_PRODUCTAPP: string;
  /** EntityModel */
  readonly ADD_BECOMPONENT: string;
  readonly ADD_BECOMMENT: string;
  readonly ADD_INTERFACE: string;
  readonly ADD_ENTITY: string;
  readonly ADD_ENUM: string;
  readonly ADD_BUSINESSLOGIC: string;
  readonly ADD_DTO: string;
  readonly ADD_VALUEOBJECT: string;
  readonly ADD_SERVICE: string;
  readonly ADD_SERVICEACTION: string;
  readonly ADD_CONSTANT: string;
  readonly ADD_DISTRIBUTEDTRANSACTION: string;
  readonly ADD_EXTERNALSERVICE: string;
  readonly ADD_REFERENCEENTITY: string;
  readonly ADD_METHOD: string;
  /** DBModel */
  readonly ADD_DBCOMPONENT: string;
  /** UIModel */
  readonly ADD_UIMODELCOMPONENT: string;
}

/** 账号体系常量 */
interface Account {
  /** 登录账号ID */
  readonly ACCOUNT_ID: string;
  /** 用户ID */
  readonly USER_ID: string;
  /** 租户ID */
  readonly TENANCY_ID: string;
  /** satoken */
  readonly SATOKEN: string;
  /** x-ca-reqid */
  readonly XCA_REQID: string;
  /** x-ca-reqtime */
  readonly XCA_REQTIME: string;
  /** 过期时间：秒 */
  readonly LOGIN_TIMEOUT: number;
}
/**
 * 关键字
 */
interface KeyWords{
  readonly CSharp: Array<string>;
  readonly Java: Array<string>;
  readonly TypeScript: Array<string>;
  readonly JavaScript: Array<string>;
  readonly Sql: Array<string>;
  readonly YuanXingCloud: Array<string>;
}
interface ModelAction {
  readonly Link: LinkAction;
  readonly Type: TypeAction;
  readonly Account: Account;
  readonly KeyWords: KeyWords;
}

export const MDAConstant: ModelAction = {
  Link: {
    /** APPModel */
    ADD_MENUCONTAIN: 'menuContain',
    ADD_TASKSEQUENCE: 'taskSequence',
    /** ProductModel */
    /** EntityModel */
    ADD_ASSOCIATION: 'association',
    ADD_IMPLEMENT: 'implement',
    ADD_GENERALIZATION: 'generalization',
    ADD_DEPENDENCY: 'dependency',
    ADD_COMPOSITION: 'composition',
    ADD_AGGREGATION: 'aggregation',
    ADD_CROSS: 'cross'
  },
  Type: {
    /** Base */
    ADD_APP: 'app',
    ADD_PRODUCT: 'product',
    /** APPModel */
    ADD_APPCOMPONENT: 'appComponent',
    ADD_APPCOMMENT: 'appComment',
    ADD_MENUSET: 'menuSet',
    ADD_CONFIGGROUP: 'configGroup',
    /** ProductModel */
    ADD_PRODUCTCOMPONENT: 'productComponent',
    ADD_PRODUCTCOMMENT: 'productComment',
    ADD_PRODUCTAPP: 'productAPP',
    /** EntityModel */
    ADD_BECOMPONENT: 'beComponent',
    ADD_BECOMMENT: 'beComment',
    ADD_INTERFACE: 'interface',
    ADD_ENTITY: 'entity',
    ADD_ENUM: 'enum',
    ADD_BUSINESSLOGIC: 'businessLogic',
    ADD_DTO: 'dto',
    ADD_VALUEOBJECT: 'valueObject',
    ADD_SERVICE: 'service',
    ADD_SERVICEACTION: 'serviceAction',
    ADD_CONSTANT: 'constant',
    ADD_DISTRIBUTEDTRANSACTION: 'distributedTransaction',
    ADD_EXTERNALSERVICE: 'externalService',
    ADD_REFERENCEENTITY: 'referenceEntity',
    ADD_METHOD: 'method',
    /** DBModel */
    ADD_DBCOMPONENT: 'dbComponent',
    /** UIModel */
    ADD_UIMODELCOMPONENT: 'uiModelComponent'
  },
  Account: {
    /** 登录账号ID */
    ACCOUNT_ID: 'accountid',
    /** 用户ID */
    USER_ID: 'userid',
    /** 租户ID */
    TENANCY_ID: 'tenancyid',
    /** satoken */
    SATOKEN: 'satoken',
    /** x-ca-reqid */
    XCA_REQID: 'x-ca-reqid',
    /** x-ca-reqtime */
    XCA_REQTIME: 'x-ca-reqtime',
    /** 过期时间：秒 */
    LOGIN_TIMEOUT: 20 * 60
  },
  KeyWords: {
    CSharp: ['abstract', 'as', 'base', 'bool', 'break', 'byte', 'case', 'catch', 'char', 'checked', 'class', 'const', 'continue', 'decimal', 'default', 'delegate', 'do', 'double', 'else', 'enum', 'event', 'explicit', 'extern', 'false', 'finally', 'fixed', 'float', 'for', 'foreach', 'goto', 'if', 'implicit', 'in', 'int', 'interface', 'internal', 'is', 'lock', 'long', 'namespace', 'new', 'null', 'object', 'operator', 'out', 'override', 'params', 'private', 'protected', 'public', 'readonly', 'ref', 'return', 'sbyte', 'sealed', 'short', 'sizeof', 'stackalloc', 'static', 'string', 'struct', 'switch', 'this', 'throw', 'true', 'try', 'typeof', 'uint', 'ulong', 'unchecked', 'unsafe', 'ushort', 'using', 'virtual', 'void', 'volatile', 'while'],
    Java: ['abstract', 'assert', 'boolean', 'break', 'byte', 'case', 'catch', 'char', 'class', 'const', 'continue', 'default', 'do', 'double', 'else', 'enum', 'extends', 'final', 'finally', 'float', 'for', 'goto', 'if', 'implements', 'import', 'instanceof', 'int', 'interface', 'long', 'native', 'new', 'null', 'package', 'private', 'protected', 'public', 'return', 'short', 'static', 'strictfp', 'super', 'switch', 'synchronized', 'this', 'throw', 'throws', 'transient', 'try', 'void', 'volatile', 'while'],
    TypeScript: ['any', 'as', 'boolean', 'break', 'case', 'catch', 'class', 'const', 'constructor', 'continue', 'debugger', 'declare', 'default', 'delete', 'do', 'else', 'enum', 'export', 'extends', 'false', 'finally', 'for', 'from', 'function', 'get', 'if', 'implements', 'import', 'in', 'instanceof', 'interface', 'let', 'module', 'namespace', 'never', 'new', 'null', 'number', 'object', 'package', 'private', 'protected', 'public', 'readonly', 'require', 'return', 'set', 'static', 'string', 'super', 'switch', 'symbol', 'this', 'throw', 'true', 'try', 'type', 'typeof', 'undefined', 'var', 'void', 'while', 'with', 'yield'],
    JavaScript: ['break', 'case', 'catch', 'class', 'const', 'continue', 'debugger', 'default', 'delete', 'do', 'else', 'enum', 'export', 'extends', 'false', 'finally', 'for', 'function', 'if', 'import', 'in', 'instanceof', 'new', 'null', 'return', 'super', 'switch', 'this', 'throw', 'true', 'try', 'typeof', 'var', 'void', 'while', 'with'],
    Sql: ['ADD', 'ALTER', 'AND', 'AS', 'ASC', 'BACKUP', 'BETWEEN', 'CASE', 'CHECK', 'COLUMN', 'CONSTRAINT', 'CREATE', 'DATABASE', 'DEFAULT', 'DELETE', 'DESC', 'DISTINCT', 'DROP', 'EXEC', 'EXISTS', 'FOREIGN', 'FROM', 'FULL', 'GROUP BY', 'HAVING', 'IN', 'INDEX', 'INNER', 'INSERT', 'INTO', 'IS', 'JOIN', 'KEY', 'LEFT', 'LIKE', 'LIMIT', 'NOT', 'NULL', 'OR', 'ORDER BY', 'OUTER', 'PRIMARY', 'PROCEDURE', 'RIGHT', 'ROWNUM', 'SELECT', 'SET', 'TABLE', 'TOP', 'TRUNCATE', 'UNION', 'UNIQUE', 'UPDATE', 'VALUES', 'VIEW', 'WHERE'],
    YuanXingCloud: ['id', 'status', 'createdBy', 'createdOn', 'modifiedBy', 'modifiedOn', 'owner']
  }
};
